import { useWizardWithOperations } from "@coworker/apprestructured/src/shared/hooks/wizard/useWizardOperations/useWizardWithOperations";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import { useCloseTask } from "./api/useCloseTask";
import { useMoveUsersToTeam } from "./api/useMoveUsersToTeam";
import { useReassignTasks } from "./api/useReassignTasks";
import {
  isCloseTaskOperation,
  isMoveUsersToTeamOperation,
  isReassignTasksOperation,
  TeamDeletionOperation,
} from "./TeamDeletionOperations";

export enum TeamDeletionWizardSteps {
  DELETE_TEAM_CONFIRMATION = "DELETE_TEAM_CONFIRMATION",
  USERS = "USERS",
  TASKS = "TASKS",
}

type UseTeamDeletionFlowArgs = {
  wizardSteps: readonly TeamDeletionWizardSteps[];
  onComplete: () => Promise<void>;
};

export const useTeamDeletionFlow = ({
  wizardSteps,
  onComplete,
}: UseTeamDeletionFlowArgs) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  const { resignTasks } = useReassignTasks();
  const { closeTask } = useCloseTask();
  const { moveUsersToTeam } = useMoveUsersToTeam();

  return useWizardWithOperations<
    TeamDeletionWizardSteps,
    TeamDeletionOperation
  >({
    steps: wizardSteps,
    onError: () => showToast(t("errorBoundaryString")),
    executeOperation: (operation) => {
      if (isReassignTasksOperation(operation)) {
        return resignTasks(operation.payload);
      }
      if (isCloseTaskOperation(operation)) {
        return closeTask(operation.payload);
      }
      if (isMoveUsersToTeamOperation(operation)) {
        return moveUsersToTeam(operation.payload);
      }
      return Promise.resolve();
    },
    onComplete,
  });
};
